module.exports = __webpack_public_path__ + "img/597.a419de77.jpg";